/* eslint-disable */
import type Keycloak from 'keycloak-js';

import { ZopNavigationItem } from '@zopup/zop-ux-core';

export const defaultNavigation: ZopNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    tooltip: 'Dashboards',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'tenant-management',
    title: 'Tenant Management',
    tooltip: 'Tenant Management',
    type: 'aside',
    icon: 'heroicons_outline:shopping-bag',
    children: [
      {
        id: 'tenant-management.packages',
        title: 'Subscription Packages',
        tooltip: 'Subscription Packages',
        type: 'basic',
        icon: 'heroicons_outline:gift',
        link : '/tenant-management/subscription-packages',
      },
      {
        id: 'tenant-management.tenants',
        title: 'Tenants',
        tooltip: 'tenants',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link : '/tenant-management/tenants',
      },
    ], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'users',
    title: 'Users',
    tooltip: 'Users',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'divider-1',
    type: 'divider',
  },
  {
    id: 'masters',
    title: 'Masters',
    tooltip: 'Masters',
    type: 'aside',
    icon: 'heroicons_outline:squares-2x2',
    children: [
      {
        id   : 'masters.attributes',
        title: 'Attributes',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/attributes',
      },
      {
        id   : 'masters.brands',
        title: 'Brands',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/brands',
      },
      {
        id   : 'masters.businessTypes',
        title: 'Business Types',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/business-types',
      },
      {
        id   : 'masters.categories',
        title: 'Categories',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/categories',
      },
      {
        id   : 'masters.manufacturers',
        title: 'Manufacturers',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/manufacturers',
      },
      {
        id   : 'masters.productCatalogue',
        title: 'Product Catalogue',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/catalogue',
      },
      {
        id   : 'masters.statutoryMaster',
        title: 'Statutory Master',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/statutory-master',
      },
      {
        id   : 'masters.taxMaster',
        title: 'Tax Master',
        type : 'basic',
        icon : 'heroicons_outline:clipboard-document-check',
        link : '/masters/tax-master',
      },
    ], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];

export const compactNavigation = (keycloak: Keycloak): ZopNavigationItem[] => [
  {
    id: 'dashboards',
    title: 'Dashboards',
    tooltip: 'Dashboards',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'tenant-management',
    title: 'Tenant Management',
    tooltip: 'Tenant Management',
    type: 'aside',
    icon: 'heroicons_outline:shopping-bag',
    children: [ ], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'users',
    title: 'Users',
    tooltip: 'Users',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'signout',
    title: 'Sign Out',
    tooltip: 'User Sign Out',
    type: 'basic',
    icon: 'heroicons_outline:arrow-right-start-on-rectangle',
    function: async()=>{ 
        await keycloak.logout({
            redirectUri: window.location.origin + '/sign-in'
      });
    }
  },
  {
    id: 'divider-1',
    type: 'divider',
  },
  {
    id: 'masters',
    title: 'Masters',
    tooltip: 'Masters',
    type: 'aside',
    icon: 'heroicons_outline:squares-2x2',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const futuristicNavigation: ZopNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'DASHBOARDS',
    type: 'group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'APPS',
    type: 'group',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'others',
    title: 'OTHERS',
    type: 'group',
  },
  {
    id: 'pages',
    title: 'Pages',
    type: 'aside',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'User Interface',
    type: 'aside',
    icon: 'heroicons_outline:rectangle-stack',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Navigation Features',
    type: 'aside',
    icon: 'heroicons_outline:bars-3',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
export const horizontalNavigation: ZopNavigationItem[] = [
  {
    id: 'dashboards',
    title: 'Dashboards',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'apps',
    title: 'Apps',
    type: 'group',
    icon: 'heroicons_outline:qrcode',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'pages',
    title: 'Pages',
    type: 'group',
    icon: 'heroicons_outline:document-duplicate',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'user-interface',
    title: 'UI',
    type: 'group',
    icon: 'heroicons_outline:rectangle-stack',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
  {
    id: 'navigation-features',
    title: 'Misc',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
  },
];
